<template>
  <RevList :has-external-borders="false">
    <RevAccordionItem>
      <template #title>
        {{ i18n(translations.question1) }}
      </template>
      <template #body>
        <div>
          {{ i18n(translations.answer1) }}
        </div>
      </template>
    </RevAccordionItem>
    <RevAccordionItem>
      <template #title>
        {{ i18n(translations.question2) }}
      </template>
      <template #body>
        <div>
          {{ i18n(translations.answer2) }}
        </div>
      </template>
    </RevAccordionItem>
    <RevAccordionItem>
      <template #title>
        {{ i18n(translations.question3) }}
      </template>
      <template #body>
        <div>
          {{ i18n(translations.answer3) }}
        </div>
      </template>
    </RevAccordionItem>
    <RevAccordionItem>
      <template #title>
        {{ i18n(translations.question4) }}
      </template>
      <template #body>
        <div>
          {{ i18n(translations.answer4) }}
        </div>
      </template>
    </RevAccordionItem>
    <RevAccordionItem>
      <template #title>
        {{ i18n(translations.question5) }}
      </template>
      <template #body>
        <div>
          {{ i18n(translations.answer5) }}
        </div>
      </template>
    </RevAccordionItem>
  </RevList>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevList } from '@ds/components/List'

import translations from './Faq.translations'

const i18n = useI18n()
</script>
